var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoginSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-223"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.65,
    cy: 98.98,
    r: 20.32,
    transform: "translate(-16.12 59.55) rotate(-13.28)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.65,
    cy: 98.98,
    r: 17.28,
    transform: "translate(-16.12 59.55) rotate(-13.28)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "246.84 110.84 246.84 98.76 238.84 103.29",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.84,111.7a.86.86,0,0,1-.86-.86v-10.6l-6.72,3.8a.86.86,0,1,1-.85-1.5l8-4.53a.86.86,0,0,1,1.28.75v12.08A.86.86,0,0,1,246.84,111.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.2,
    y: 124.98,
    width: 65.78,
    height: 84.65,
    transform: "translate(567.4 -232.78) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.34,
    y: 137.14,
    width: 79.52,
    height: 60.34,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.9,
    y: 143.65,
    width: 9.59,
    height: 13.56,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.89,
    y: 147.65,
    width: 10.1,
    height: 14.51,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 365.65,
    y: 177.78,
    width: 10.1,
    height: 14.51,
    transform: "matrix(0.99, 0.13, -0.13, 0.99, 27.3, -46.77)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.17,
    y: 177.19,
    width: 10.1,
    height: 14.51,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.1,
    y: 175.66,
    width: 10.1,
    height: 14.51,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.35,
    y: 144.63,
    width: 6.27,
    height: 6.27,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 420.54,
    y: 145.21,
    width: 6.27,
    height: 6.27,
    transform: "translate(81.01 -141.63) rotate(20.94)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.49,145.43a.37.37,0,0,1-.37.36.37.37,0,1,1,0-.73A.37.37,0,0,1,415.49,145.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.7,145.43a.37.37,0,1,1-.37-.37A.37.37,0,0,1,422.7,145.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.3,148.72a.37.37,0,0,1-.73,0,.37.37,0,1,1,.73,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.06,144.63a.37.37,0,1,1-.73,0,.37.37,0,0,1,.73,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.62,178.23a.36.36,0,0,1-.37.36.37.37,0,1,1,0-.73A.36.36,0,0,1,367.62,178.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.52,176.49a.37.37,0,1,1-.37-.37A.37.37,0,0,1,384.52,176.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.58,177.86a.37.37,0,1,1-.37-.37A.37.37,0,0,1,396.58,177.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.75,
    y: 164.24,
    width: 20.11,
    height: 12.61,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.42,
    y: 178.59,
    width: 17.56,
    height: 13.86,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.02,
    y: 124.98,
    width: 65.78,
    height: 84.65,
    transform: "translate(267.22 67.4) rotate(90)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.15,
    y: 137.14,
    width: 79.52,
    height: 60.34,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.86,
    y: 165.58,
    width: 9.59,
    height: 13.56,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.85,
    y: 169.59,
    width: 10.1,
    height: 14.51,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.56,
    y: 144.63,
    width: 10.1,
    height: 14.51,
    transform: "translate(20.69 -12.09) rotate(7.49)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.08,
    y: 144.03,
    width: 10.1,
    height: 14.51,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.01,
    y: 142.51,
    width: 10.1,
    height: 14.51,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.06,
    y: 142.08,
    width: 6.27,
    height: 6.27,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.25,
    y: 142.66,
    width: 6.27,
    height: 6.27,
    transform: "translate(57.29 -18.39) rotate(20.94)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2,142.87a.37.37,0,1,1-.37-.36A.37.37,0,0,1,70.2,142.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.41,142.87a.37.37,0,1,1-.73,0,.37.37,0,0,1,.73,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.66,158a.37.37,0,1,1-.37-.36A.37.37,0,0,1,103.66,158Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,166.57a.37.37,0,1,1-.37-.37A.38.38,0,0,1,94,166.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.53,145.08a.37.37,0,0,1-.73,0,.37.37,0,1,1,.73,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116.06,
    cy: 143.33,
    r: 0.37,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.49,144.71a.37.37,0,1,1-.73,0,.37.37,0,1,1,.73,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.63,
    y: 180.19,
    width: 20.11,
    height: 12.61,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.63,
    y: 178.59,
    width: 17.56,
    height: 13.86,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-223"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-223",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-2--inject-223"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M423.63,355c-.17,1.23,3.17,2,5.89,2.5-.22,2.24-1.71,4.5-3.76,6.61-2.59-1.46-6.28-3.38-7-2.91s3,2.95,5.4,4.39a48.39,48.39,0,0,1-5.36,4.06c-1.15-1.08-2.51-2-3.32-1.52s-.61,2.21-.2,3.7c-2.81,1.64-4.92,2.64-4.92,2.64a57.1,57.1,0,0,1-1.88-8c.14-.28.28-.56.41-.86.46-1.05,0-1.49-.73-1.64a27.77,27.77,0,0,1-.05-5.76c3.19-.66,7.06-1.9,5.61-3.81-.88-1.15-2.48-1.28-4.14-1a6.53,6.53,0,0,1,.78-1.07c5.8-6.39,9.84,0,9.84,0,3.37-2.81,8.1-2.05,9.12,2.33C427.47,354.2,423.85,353.48,423.63,355Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.63,355c-.17,1.23,3.17,2,5.89,2.5-.22,2.24-1.71,4.5-3.76,6.61-2.59-1.46-6.28-3.38-7-2.91s3,2.95,5.4,4.39a48.39,48.39,0,0,1-5.36,4.06c-1.15-1.08-2.51-2-3.32-1.52s-.61,2.21-.2,3.7c-2.81,1.64-4.92,2.64-4.92,2.64a57.1,57.1,0,0,1-1.88-8c.14-.28.28-.56.41-.86.46-1.05,0-1.49-.73-1.64a27.77,27.77,0,0,1-.05-5.76c3.19-.66,7.06-1.9,5.61-3.81-.88-1.15-2.48-1.28-4.14-1a6.53,6.53,0,0,1,.78-1.07c5.8-6.39,9.84,0,9.84,0,3.37-2.81,8.1-2.05,9.12,2.33C427.47,354.2,423.85,353.48,423.63,355Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.4,401.93l.84-.07c0-.43-3.43-43.19,6.16-47.22a3.27,3.27,0,0,1,2.91.07c3.47,1.81,5.13,9.29,5.14,9.37l.82-.18c-.07-.32-1.76-7.94-5.57-9.93a4.07,4.07,0,0,0-3.62-.1C412.93,358.13,416.25,400.14,416.4,401.93Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.19,401c.17-1.92,4.09-47.16-3.24-52-1.75-1.15-3.32-1.4-4.65-.73-3.46,1.75-3.91,9.15-3.93,9.46l.84.05c0-.07.44-7.23,3.47-8.76,1-.52,2.33-.3,3.82.68,6.9,4.53,2.9,50.72,2.86,51.19Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.09,404.66c.06-1.47,1.26-36.1-5.41-39.13a4.69,4.69,0,0,0-4,0c-4.58,2-7.41,10.55-7.52,10.91l.79.26c0-.09,2.83-8.54,7.06-10.4a3.87,3.87,0,0,1,3.29,0c5.11,2.32,5.28,28.46,4.91,38.34Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.79,403.08l.83-.1c-1.17-10.31-3.42-37.77.25-41.05a1.43,1.43,0,0,1,1.5-.46c2.46.94,4,9.88,4.33,13.24l.83-.09c-.14-1.29-1.48-12.64-4.86-13.93a2.22,2.22,0,0,0-2.36.62C411.57,365.54,415.61,401.54,415.79,403.08Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.77 383.54 399.66 383.54 402.18 417.27 427.26 417.27 429.77 383.54",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.63 383.54 419.79 417.27 402.18 417.27 399.66 383.54 420.63 383.54",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.67,371.16c.32.82,2.66.17,4.49-.48a8.42,8.42,0,0,1-.05,5.37c-2.1,0-5,.06-5.29.59s2.88.78,4.83.86a33.63,33.63,0,0,1-1.91,4.33c-1.08-.27-2.25-.39-2.57.21s.38,1.57,1.15,2.35c-1.17,2-2.13,3.31-2.13,3.31a39.52,39.52,0,0,1-3.9-4.28c0-.22,0-.44,0-.67-.08-.8-.51-.93-1-.76a20.13,20.13,0,0,1-2-3.54c1.74-1.5,3.7-3.59,2.15-4.27a2.88,2.88,0,0,0-2.89.81,4.73,4.73,0,0,1,.11-.93c1.39-5.93,6.07-3.38,6.07-3.38,1.12-2.88,4.29-4,6.43-1.68C427.77,369.35,425.29,370.15,425.67,371.16Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.67,371.16c.32.82,2.66.17,4.49-.48a8.42,8.42,0,0,1-.05,5.37c-2.1,0-5,.06-5.29.59s2.88.78,4.83.86a33.63,33.63,0,0,1-1.91,4.33c-1.08-.27-2.25-.39-2.57.21s.38,1.57,1.15,2.35c-1.17,2-2.13,3.31-2.13,3.31a39.52,39.52,0,0,1-3.9-4.28c0-.22,0-.44,0-.67-.08-.8-.51-.93-1-.76a20.13,20.13,0,0,1-2-3.54c1.74-1.5,3.7-3.59,2.15-4.27a2.88,2.88,0,0,0-2.89.81,4.73,4.73,0,0,1,.11-.93c1.39-5.93,6.07-3.38,6.07-3.38,1.12-2.88,4.29-4,6.43-1.68C427.77,369.35,425.29,370.15,425.67,371.16Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.31,375.16a11.69,11.69,0,0,1,2.76.58,6.35,6.35,0,0,0,.4-2c.19-6.07-4.15-3.51-6.45-5.3a5,5,0,0,0-3.85-1.2,6.73,6.73,0,0,1,.52,1,1,1,0,0,1-.73,1.3,2.8,2.8,0,0,1-1.71-.21,3.11,3.11,0,0,1-.44-.3,8.46,8.46,0,0,0-.83,2,12,12,0,0,0-.39,2.6,8.94,8.94,0,0,1,1,.29.94.94,0,0,1,.38,1.44,4.3,4.3,0,0,1-1.25.88,14.56,14.56,0,0,0,.76,2.85l.31,0c.23.05.44.1.66.17a1.55,1.55,0,0,1,.36.13,1,1,0,0,1,.57.73.93.93,0,0,1-.36.88,3.4,3.4,0,0,1-.45.28,6.67,6.67,0,0,0,2.41,2.43,26.82,26.82,0,0,0,2.56-1.35c-.19-.25-.37-.49-.54-.74a1.48,1.48,0,0,1-.25-1,1.26,1.26,0,0,1,.49-.85,1.29,1.29,0,0,1,.95-.26,1.33,1.33,0,0,1,.86.49c.2.3.42.58.64.87a16.18,16.18,0,0,0,3.09-3l-.1,0a9.86,9.86,0,0,0-1.71-.29,1.3,1.3,0,0,1-1.11-1.44A1.31,1.31,0,0,1,403.31,375.16Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.31,375.16a11.69,11.69,0,0,1,2.76.58,6.35,6.35,0,0,0,.4-2c.19-6.07-4.15-3.51-6.45-5.3a5,5,0,0,0-3.85-1.2,6.73,6.73,0,0,1,.52,1,1,1,0,0,1-.73,1.3,2.8,2.8,0,0,1-1.71-.21,3.11,3.11,0,0,1-.44-.3,8.46,8.46,0,0,0-.83,2,12,12,0,0,0-.39,2.6,8.94,8.94,0,0,1,1,.29.94.94,0,0,1,.38,1.44,4.3,4.3,0,0,1-1.25.88,14.56,14.56,0,0,0,.76,2.85l.31,0c.23.05.44.1.66.17a1.55,1.55,0,0,1,.36.13,1,1,0,0,1,.57.73.93.93,0,0,1-.36.88,3.4,3.4,0,0,1-.45.28,6.67,6.67,0,0,0,2.41,2.43,26.82,26.82,0,0,0,2.56-1.35c-.19-.25-.37-.49-.54-.74a1.48,1.48,0,0,1-.25-1,1.26,1.26,0,0,1,.49-.85,1.29,1.29,0,0,1,.95-.26,1.33,1.33,0,0,1,.86.49c.2.3.42.58.64.87a16.18,16.18,0,0,0,3.09-3l-.1,0a9.86,9.86,0,0,0-1.71-.29,1.3,1.3,0,0,1-1.11-1.44A1.31,1.31,0,0,1,403.31,375.16Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.58,354.22a8.15,8.15,0,0,0-1.7-.9,3.91,3.91,0,0,1,.66-1.22c2.56-3.28,3.72,0,5.71,0a3.39,3.39,0,0,1,2.55,1.05,5.22,5.22,0,0,0-.73.32.64.64,0,0,0-.18,1,1.9,1.9,0,0,0,1,.64,2.21,2.21,0,0,0,.37,0,5.86,5.86,0,0,1-.46,1.43,7.79,7.79,0,0,1-.93,1.54,6.62,6.62,0,0,0-.66-.3.65.65,0,0,0-.83.59,3,3,0,0,0,.27,1,10.06,10.06,0,0,1-1.65,1.16l-.19-.12-.41-.2a1.84,1.84,0,0,0-.25-.09.66.66,0,0,0-.62.14.65.65,0,0,0-.2.62,2,2,0,0,0,.12.34,4.6,4.6,0,0,1-2.33.22,17.1,17.1,0,0,1-.75-1.83l.6-.16a.93.93,0,0,0,.55-.38.88.88,0,0,0,.12-.67.89.89,0,0,0-1.05-.67c-.24.07-.48.12-.72.17a10.51,10.51,0,0,1-.31-2.92l.06,0a7.09,7.09,0,0,1,1,.6.89.89,0,0,0,1.22-.27A.91.91,0,0,0,401.58,354.22Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.58,354.22a8.15,8.15,0,0,0-1.7-.9,3.91,3.91,0,0,1,.66-1.22c2.56-3.28,3.72,0,5.71,0a3.39,3.39,0,0,1,2.55,1.05,5.22,5.22,0,0,0-.73.32.64.64,0,0,0-.18,1,1.9,1.9,0,0,0,1,.64,2.21,2.21,0,0,0,.37,0,5.86,5.86,0,0,1-.46,1.43,7.79,7.79,0,0,1-.93,1.54,6.62,6.62,0,0,0-.66-.3.65.65,0,0,0-.83.59,3,3,0,0,0,.27,1,10.06,10.06,0,0,1-1.65,1.16l-.19-.12-.41-.2a1.84,1.84,0,0,0-.25-.09.66.66,0,0,0-.62.14.65.65,0,0,0-.2.62,2,2,0,0,0,.12.34,4.6,4.6,0,0,1-2.33.22,17.1,17.1,0,0,1-.75-1.83l.6-.16a.93.93,0,0,0,.55-.38.88.88,0,0,0,.12-.67.89.89,0,0,0-1.05-.67c-.24.07-.48.12-.72.17a10.51,10.51,0,0,1-.31-2.92l.06,0a7.09,7.09,0,0,1,1,.6.89.89,0,0,0,1.22-.27A.91.91,0,0,0,401.58,354.22Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.11,360.3c.18,1.23-3.16,2.05-5.89,2.5.22,2.24,1.71,4.5,3.77,6.61,2.58-1.46,6.28-3.38,7-2.91s-3,3-5.41,4.39A49.34,49.34,0,0,0,430.9,375c1.16-1.08,2.52-2,3.32-1.52s.62,2.21.2,3.71c2.82,1.64,4.92,2.63,4.92,2.63a57.17,57.17,0,0,0,1.88-8c-.14-.28-.28-.57-.41-.87-.45-1.05,0-1.49.74-1.64a27.67,27.67,0,0,0,0-5.75c-3.18-.67-7-1.91-5.6-3.82.87-1.15,2.47-1.28,4.14-1a6,6,0,0,0-.79-1.07c-5.79-6.39-9.84,0-9.84,0-3.36-2.81-8.09-2-9.12,2.34C422.28,359.5,425.89,358.78,426.11,360.3Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.11,360.3c.18,1.23-3.16,2.05-5.89,2.5.22,2.24,1.71,4.5,3.77,6.61,2.58-1.46,6.28-3.38,7-2.91s-3,3-5.41,4.39A49.34,49.34,0,0,0,430.9,375c1.16-1.08,2.52-2,3.32-1.52s.62,2.21.2,3.71c2.82,1.64,4.92,2.63,4.92,2.63a57.17,57.17,0,0,0,1.88-8c-.14-.28-.28-.57-.41-.87-.45-1.05,0-1.49.74-1.64a27.67,27.67,0,0,0,0-5.75c-3.18-.67-7-1.91-5.6-3.82.87-1.15,2.47-1.28,4.14-1a6,6,0,0,0-.79-1.07c-5.79-6.39-9.84,0-9.84,0-3.36-2.81-8.09-2-9.12,2.34C422.28,359.5,425.89,358.78,426.11,360.3Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plant-1--inject-223"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.5,391.26l-.79,0c0-1.16,1-28.48,5.72-33.11s10.64-.06,10.7,0l-.5.6c-.22-.17-5.27-4.28-9.65,0C87.45,363.09,86.5,391,86.5,391.26Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.11,396.75l-.78-.08c0-.33,3.07-33.18-8.83-46.84l.59-.51C89.21,363.23,86.14,396.41,86.11,396.75Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.48,393.24c-.1-1.55-2.39-38.07,6.76-46.48l.53.57c-8.88,8.17-6.53,45.48-6.51,45.85Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.33,393.21c0-.24-.29-24.78-6.79-28.51a4.18,4.18,0,0,0-3.79-.39c-3.82,1.58-5.85,8.86-5.87,8.93l-.75-.2c.09-.32,2.15-7.73,6.32-9.45a4.92,4.92,0,0,1,4.48.44c6.88,3.94,7.17,28.15,7.18,29.18Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,393.23c0-.79-1-19.39,4.22-26.27,1.4-1.83,3-2.71,4.65-2.58,3.75.26,6.65,5.34,6.78,5.56l-.69.38c0-.05-2.82-4.93-6.15-5.16-1.4-.11-2.74.67-4,2.27-5.09,6.66-4.07,25.57-4.06,25.76Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,395.81l-.78-.06c0-.45,3.32-44.77-2.14-52.16l.63-.46C90.29,350.75,87.09,394,87,395.81Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.93,368s3.38,1.25,2.38,4.18S63.62,380,63.62,380s-4.47-4.1-.36-10.76S72.84,365.9,72.93,368Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.93,368s3.38,1.25,2.38,4.18S63.62,380,63.62,380s-4.47-4.1-.36-10.76S72.84,365.9,72.93,368Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.61,362.41s-3.59-.15-3.8,2.94S91.6,377,91.6,377s5.71-2.06,4.48-9.8S88.51,360.5,87.61,362.41Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.61,362.41s-3.59-.15-3.8,2.94S91.6,377,91.6,377s5.71-2.06,4.48-9.8S88.51,360.5,87.61,362.41Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.66,347.57s-2.4-.26-2.21-1.72,9.32-5.22,14.71.86c0,0-3.45,5.92-8.43,6S90.66,347.57,90.66,347.57Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.66,347.57s-2.4-.26-2.21-1.72,9.32-5.22,14.71.86c0,0-3.45,5.92-8.43,6S90.66,347.57,90.66,347.57Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.19,344s2.17,1.05,2.78-.29-5.15-9.36-12.93-7.05c0,0-.21,6.85,4,9.56S86.19,344,86.19,344Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.19,344s2.17,1.05,2.78-.29-5.15-9.36-12.93-7.05c0,0-.21,6.85,4,9.56S86.19,344,86.19,344Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.54,366.82s-1.65-1.34.13-2,10.55-.47,10.64,8.21c0,0-10.2,1.7-11.47-1.61S97.54,366.82,97.54,366.82Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.54,366.82s-1.65-1.34.13-2,10.55-.47,10.64,8.21c0,0-10.2,1.7-11.47-1.61S97.54,366.82,97.54,366.82Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.73,347.35s1.66-1.33-.13-2S66.05,344.9,66,353.58c0,0,10.21,1.69,11.47-1.61S76.73,347.35,76.73,347.35Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.73,347.35s1.66-1.33-.13-2S66.05,344.9,66,353.58c0,0,10.21,1.69,11.47-1.61S76.73,347.35,76.73,347.35Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.13,354.34s.14-1.62-1.17-1-5.88,5.56-1.14,10.24c0,0,6.37-4.72,5.22-7.18S82.13,354.34,82.13,354.34Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.13,354.34s.14-1.62-1.17-1-5.88,5.56-1.14,10.24c0,0,6.37-4.72,5.22-7.18S82.13,354.34,82.13,354.34Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,356.66s-1-1.3.46-1.46,7.94,1.57,6.43,8.05c0,0-7.91-.59-8.25-3.28S99,356.66,99,356.66Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,356.66s-1-1.3.46-1.46,7.94,1.57,6.43,8.05c0,0-7.91-.59-8.25-3.28S99,356.66,99,356.66Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.3 417.27 99.44 417.27 102.36 387.56 69.37 387.56 72.3 417.27",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.3 417.27 99.44 417.27 102.36 387.56 69.37 387.56 72.3 417.27",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.93,
    y: 384.28,
    width: 35.89,
    height: 6.56,
    transform: "translate(171.74 775.12) rotate(180)",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.93,
    y: 384.28,
    width: 35.89,
    height: 6.56,
    transform: "translate(171.74 775.12) rotate(180)",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flag--inject-223"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.43,134.51v72.66C123.09,210.11,120,216,117,223.4c-4.51,11-8.79,25.23-13.3,37.37-3.54,9.5-7.22,17.73-11.27,22.13-2.9-13.27-6.35-29-10.51-48,3.22-2.67,6.22-7.61,9.08-13.94,8.1-17.89,15.09-46.79,22.71-66.35C117.69,144.39,121.85,136.73,126.43,134.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.43,139.09c-6.17,16.92-11.67,44.81-16.49,71.3,5.76-6.13,11.28-10.51,16.49-5.94v2.72a22,22,0,0,0-4,5.19c-4.87.1-9.84,5.85-15,11.84-3.7,20.61-7,39.26-10.73,52.66a34.94,34.94,0,0,1-4.3,6L92,281.11c4.53-11.95,8.21-30.93,12.11-53.14-6.06,6.72-12.65,12.47-21.57,9.92q-.33-1.48-.66-3a28.38,28.38,0,0,0,5.78-7c6.51-.8,11.9-6.12,17-11.74l1.85-2c4.26-24.64,9-52.33,14.63-74.13,1.77-2.73,3.52-4.63,5.25-5.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.78,226.11l0-.13c-1,1.13-2,2.24-3.06,3.29-5.47,5.59-11.51,9.75-19.45,7.41l-.39-1.79A19.7,19.7,0,0,0,83.85,233c7.42,1.28,13.23-3.23,18.57-8.83.88-.92,1.74-1.87,2.6-2.83.22.69.44,1.37.65,2C105.37,224.32,105.08,225.22,104.78,226.11Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.7,226.67c-.27,1.52-.54,3-.8,4.52C102.59,249.61,99.5,266,96.06,278a37.88,37.88,0,0,1-2.62,3.75c4.25-12.16,7.8-30.73,11.6-52.15q.46-2.58.93-5.22C106.21,225.13,106.46,225.91,106.7,226.67Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.28,212.42l0,0c.77-4.27,1.55-8.59,2.36-12.92,4.42-23.71,9.38-47.39,14.83-62.31v-2.72a7.51,7.51,0,0,0-1.66,1.11c-5.31,16.63-10.08,40.67-14.34,64.14q-1,5.6-2,11.09c0,1.46-.06,2.9-.09,4.33C108.67,214.26,109,213.34,109.28,212.42Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.23,222.06l1.11-1.28c4.73-5.36,9.3-9.92,13.76-9.48a23.36,23.36,0,0,1,2.45-3.27c-5.08-3.17-10.4,1.59-15.93,7.68l-1.29,1.44C108.29,218.81,108.26,220.44,108.23,222.06Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.43,167.77v15.56c-5.67,4.26-11.21,19.27-16.52,35.14.55,7.31,1.06,14.15,1.54,20.56-1.43,4.15-2.83,8.34-4.24,12.41-.61-5.93-1.26-12.24-1.95-19-5,14.86-10,28.29-16.3,34.65l-2.25-10.29c6.79-6.42,12-20.77,17.28-36.72-.84-8.13-1.74-16.88-2.71-26.34,1.8-5.68,3.61-11.59,5.46-17.42.77,10.32,1.49,19.85,2.16,28.69C114.52,187.93,120.4,171.78,126.43,167.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.44,171.4c-6.25,4.28-12.31,21.51-18.1,39.19-.77-9.59-1.59-20-2.5-31.41-1.24,4-2.47,7.94-3.69,11.83,1,10.73,2,20.57,2.91,29.63-5.45,16.62-10.82,31.87-17.82,38.58.42,1.94.84,3.83,1.24,5.69,6.75-6.68,12-21.37,17.26-37.35.77,7.85,1.49,15.13,2.15,21.91l2.87-8.42c-.57-7.15-1.18-14.84-1.84-23.13,5.61-17,11.47-33.49,17.52-37.91Z",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.8,
    y: 126.11,
    width: 4.6,
    height: 291.16,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.8,
    y: 126.11,
    width: 4.6,
    height: 291.16,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.11 393.95 118.09 393.95 111.19 417.27 143.01 417.27 136.11 393.95",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.1,
    cy: 127.79,
    r: 4.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.1,
    cy: 127.79,
    r: 4.05,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,223.4c-4.51,11-8.79,25.23-13.3,37.37C98.91,253.7,94.22,235.66,91,221c8.1-17.89,15.09-46.79,22.71-66.35C115.28,170.29,117.65,198.87,117,223.4Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Blackboard--inject-223"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.16,413.59h-5.42V267.27h-6.83V413.59h-5.42A1.52,1.52,0,0,0,303,415.1v2.17h20.71V415.1A1.52,1.52,0,0,0,322.16,413.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.08,413.59h-5.42V267.27h-6.83V413.59h-5.42a1.52,1.52,0,0,0-1.52,1.51v2.17H195.6V415.1A1.52,1.52,0,0,0,194.08,413.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.16,413.59h-5.42V267.27h-6.83V413.59h-5.42A1.52,1.52,0,0,0,303,415.1v2.17h20.71V415.1A1.52,1.52,0,0,0,322.16,413.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.08,413.59h-5.42V267.27h-6.83V413.59h-5.42a1.52,1.52,0,0,0-1.52,1.51v2.17H195.6V415.1A1.52,1.52,0,0,0,194.08,413.59Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 152.51,
    y: 133.94,
    width: 193.55,
    height: 142.74,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.51,
    y: 133.94,
    width: 193.55,
    height: 142.74,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.92,
    y: 113.54,
    width: 132.74,
    height: 183.55,
    transform: "translate(454.59 -43.97) rotate(90)",
    style: {
      fill: "#1890FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.92,
    y: 113.54,
    width: 132.74,
    height: 183.55,
    transform: "translate(454.59 -43.97) rotate(90)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.53,206c-1.55-1.94-2.84-4.1-4.56-6a3.09,3.09,0,0,1-.7-1.25,7.27,7.27,0,0,0-4,.61c-4.84,2.17-9.25,5.84-13.08,9.46-.82.77-1.66,1.5-2.5,2.24,3.78-4.22,7.56-8.45,11.39-12.63a6.13,6.13,0,0,0,1.71-4.42,42.75,42.75,0,0,0-5.83-5.51,3.8,3.8,0,0,1-1-1,5.69,5.69,0,0,0-3.86,2c-8.19,8.9-16.3,17.65-25.35,25.63.73-1,1.46-2,2.16-3.07,4.75-7.05,9.84-13.82,15.15-20.46,3.74-4.68,10.2-10.43,11.39-16.63-.24-.3-.49-.61-.75-.91s-.67-.77-1-1.14a2.72,2.72,0,0,1-.94-.37c-1.59-1-2.6-3.16-1.33-4.9a4.09,4.09,0,0,1,1-1c1.93-2.43,3.82-4.88,5.62-7.41a4.65,4.65,0,0,0,.26-.41c-1.29-3.71-4.37-6.4-7.37-8.93a5.49,5.49,0,0,0-2.82,1.68c-3.61,3.91-7.75,7.36-11.09,11.51-3.59,4.45-6.55,9.37-9.95,13.95a1.84,1.84,0,0,0-.17.22c-4.12,4.58-8.25,9.15-12.25,13.83-3.48,3.52-7,7-10.44,10.42-5.43,5.5-10.94,11-16.66,16.29,1.42-2.1,2.84-4.19,4.3-6.27,6.44-9.17,13.59-17.82,20.48-26.65,3.4-4.35,6.51-8.9,9.8-13.32,2.6-3.48,6.49-6.66,8.53-10.49a6.86,6.86,0,0,0,.8-2.47,4.41,4.41,0,0,1-.63-.66,18.19,18.19,0,0,0-6.23-4.76,2.88,2.88,0,0,1-1.26-1.2,7,7,0,0,0-2.61,1.43,100.06,100.06,0,0,0-9.13,8.95,22.42,22.42,0,0,0,2.21-4.93c1.62-5.53-4.55-9.6-9.29-7.14l-.41.22a7,7,0,0,0-7.92-4.57c-1.83-2.44-5-3.72-7.91-1.53-11.86,9.06-23.16,19.09-34.35,29-1,.9-2,1.81-3,2.72a106.92,106.92,0,0,1,6.26-8.83c2.57-3.26,6.15-6.66,7.52-10.71a2.25,2.25,0,0,1-.39-.3A36,36,0,0,1,209,147a.36.36,0,0,0,0-.09c-5,1.12-10.22,4.35-14.44,6.78a105.54,105.54,0,0,0-15.36,11.09,4.19,4.19,0,0,1-.27,1.53,6.21,6.21,0,0,1-.4.82l0,.89a14.55,14.55,0,0,1,1,2.54,4.56,4.56,0,0,1,1.9,1.66,5.08,5.08,0,0,1,.63,2.64c0,.25-.06.5-.1.75a2.85,2.85,0,0,1,1,1.44,6.42,6.42,0,0,0,3.09-1.51c1.32-1.15,2.66-2.26,4-3.35-1.73,2.89-3.38,5.83-5.06,8.64-2.94,4.95-6,9.75-9.39,14.43-2.57,3.56-6,6.66-6.43,10.6,2.39,2,4.05,4.57,6.12,6.92a3.69,3.69,0,0,1,.29.4,12,12,0,0,0,6-2.21c-.55.65-1.09,1.31-1.59,2-4.53,6.2-10.93,11.21-15,17.67a6.7,6.7,0,0,0-1,2.41l1.42,1.8a3.43,3.43,0,0,1,.69,3.38l.1.09c-.17.2-.34.39-.5.6l0,0a7.54,7.54,0,0,0-1.42,2.93,32.53,32.53,0,0,0,7,7.83c3.72-.27,7-2.69,10.29-4.58,2.24-1.29,4.47-2.61,6.68-4a21.44,21.44,0,0,0-2.8,4.6,7.32,7.32,0,0,0-.53,2,4.41,4.41,0,0,1,.53.35,53.12,53.12,0,0,1,7.63,6.76,8.27,8.27,0,0,0,1-.45,60,60,0,0,0,6.27-3.94,8.85,8.85,0,0,0-.49,2.88,3.47,3.47,0,0,1,2.79.84c1.8,1.55,3.25,3.53,5,5.1a5,5,0,0,0,1.61-.71c4.71-3.19,8.7-7.39,13.2-10.87,1.13-.88,2.27-1.74,3.41-2.6a6.75,6.75,0,0,0-.32,2.78,3.28,3.28,0,0,1,1.23.63c2.16,1.74,4.27,3.53,6.41,5.3a6.19,6.19,0,0,0,1.53-.82,52.63,52.63,0,0,0,6-5,8.11,8.11,0,0,0,.24,1.11,2.64,2.64,0,0,1,2.6.22,53.2,53.2,0,0,1,5,4.06c2.49-.66,4.22-2.48,6.23-4l1-.78a6,6,0,0,0,.44.72,2.56,2.56,0,0,1,1.8.42,24,24,0,0,1,2.44,2.07l.33.31a6,6,0,0,0,2.57-.07c4.62-1.24,8.75-4.42,12.71-7.21-.78.9-1.56,1.81-2.32,2.74-2.89,3.55-7.13,7.41-8.6,11.9a3.26,3.26,0,0,1,.51.63c.55.91,1.17,1.82,1.83,2.71a23.59,23.59,0,0,1,5.81,4.8,6.51,6.51,0,0,0,.94-.32c4.65-2,8.12-5.74,11.6-9.29,2.49-2.52,4.88-5.13,7.21-7.79a5.19,5.19,0,0,0,.52,1,3.45,3.45,0,0,1,3.33.7c1,.83,2.09,1.59,3.16,2.36a6.57,6.57,0,0,0,4.86-2.63c5.19-6.75,19.75-25.16,14.9-35.56a31,31,0,0,0,6-8.06A7.51,7.51,0,0,0,326.53,206Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.43,205.39c1.55,1.94,2.84,4.1,4.56,6a3.24,3.24,0,0,1,.71,1.25,7.25,7.25,0,0,0,4-.61c4.84-2.17,9.25-5.84,13.09-9.46.81-.77,1.65-1.51,2.5-2.24-3.79,4.22-7.56,8.45-11.39,12.63a6.14,6.14,0,0,0-1.72,4.42,43.34,43.34,0,0,0,5.83,5.51,3.8,3.8,0,0,1,1,1,5.69,5.69,0,0,0,3.86-2c8.19-8.9,16.3-17.65,25.35-25.63-.72,1-1.46,2-2.16,3.07-4.75,7-9.84,13.82-15.14,20.46-3.75,4.68-10.21,10.43-11.4,16.63.25.3.49.61.75.91s.68.77,1,1.14a2.72,2.72,0,0,1,.94.37c1.59,1,2.6,3.16,1.33,4.9a3.92,3.92,0,0,1-1,1c-1.93,2.43-3.81,4.88-5.62,7.41a4.65,4.65,0,0,0-.26.41c1.3,3.71,4.37,6.39,7.37,8.93a5.46,5.46,0,0,0,2.82-1.68c3.62-3.91,7.75-7.36,11.09-11.51,3.59-4.45,6.55-9.37,9.95-14l.18-.22c4.11-4.58,8.24-9.15,12.24-13.83,3.49-3.52,7-7,10.44-10.42,5.43-5.5,10.94-11,16.66-16.29-1.42,2.1-2.84,4.19-4.3,6.27-6.44,9.17-13.59,17.82-20.48,26.65-3.4,4.35-6.51,8.9-9.8,13.32-2.6,3.48-6.49,6.66-8.53,10.49a6.86,6.86,0,0,0-.8,2.47,4,4,0,0,1,.63.66,18.13,18.13,0,0,0,6.24,4.76,2.85,2.85,0,0,1,1.25,1.2,6.89,6.89,0,0,0,2.61-1.43,101.47,101.47,0,0,0,9.14-9,22.46,22.46,0,0,0-2.22,4.93c-1.62,5.53,4.55,9.6,9.29,7.14l.41-.22a7,7,0,0,0,7.92,4.57c1.83,2.44,5,3.72,7.91,1.53,11.86-9.06,23.16-19.09,34.36-29l3-2.72a106.92,106.92,0,0,1-6.26,8.83c-2.57,3.26-6.15,6.66-7.51,10.71a3.4,3.4,0,0,1,.39.3,36.22,36.22,0,0,1,7.21,9.25s0,.06,0,.09c5-1.12,10.22-4.35,14.45-6.78a106,106,0,0,0,15.35-11.09,4.19,4.19,0,0,1,.27-1.53,7.77,7.77,0,0,1,.4-.82c0-.29,0-.59,0-.89a13.86,13.86,0,0,1-1-2.54,4.56,4.56,0,0,1-1.9-1.66,5.08,5.08,0,0,1-.63-2.64c0-.25.06-.5.1-.75a2.83,2.83,0,0,1-.95-1.44,6.45,6.45,0,0,0-3.1,1.51c-1.32,1.15-2.66,2.26-4,3.35,1.72-2.89,3.38-5.83,5.05-8.64,2.94-5,6-9.75,9.4-14.43,2.56-3.56,6-6.66,6.42-10.6-2.39-2-4.05-4.57-6.12-6.92a3.69,3.69,0,0,1-.29-.4,12,12,0,0,0-6,2.21c.55-.65,1.09-1.31,1.59-2,4.53-6.2,10.93-11.21,15-17.67a6.7,6.7,0,0,0,1-2.41l-1.42-1.8a3.46,3.46,0,0,1-.69-3.38l-.1-.09c.17-.2.34-.39.5-.6l0,0a7.7,7.7,0,0,0,1.43-2.93,32.78,32.78,0,0,0-7-7.83c-3.72.27-7,2.69-10.29,4.58q-3.36,1.94-6.68,4a21.13,21.13,0,0,0,2.8-4.59,7.32,7.32,0,0,0,.53-2,3.64,3.64,0,0,1-.52-.35,52.66,52.66,0,0,1-7.64-6.76,8.27,8.27,0,0,0-1,.45,60,60,0,0,0-6.27,3.94,8.59,8.59,0,0,0,.49-2.88,3.49,3.49,0,0,1-2.79-.84c-1.8-1.55-3.25-3.53-5-5.1a5,5,0,0,0-1.61.71c-4.71,3.19-8.7,7.39-13.2,10.87-1.13.88-2.27,1.74-3.41,2.6a6.59,6.59,0,0,0,.32-2.78,3.28,3.28,0,0,1-1.23-.63c-2.16-1.74-4.27-3.53-6.4-5.3a6.07,6.07,0,0,0-1.54.82,52.63,52.63,0,0,0-6,5,6.85,6.85,0,0,0-.24-1.11,2.64,2.64,0,0,1-2.6-.22,51.8,51.8,0,0,1-5-4.06c-2.5.66-4.23,2.48-6.24,4l-1,.78a6,6,0,0,0-.44-.72,2.57,2.57,0,0,1-1.8-.42,25.4,25.4,0,0,1-2.44-2.07l-.33-.31a6,6,0,0,0-2.57.07c-4.61,1.24-8.74,4.42-12.7,7.21.77-.9,1.55-1.81,2.31-2.74,2.89-3.55,7.13-7.41,8.6-11.9a3.68,3.68,0,0,1-.51-.63c-.55-.91-1.17-1.82-1.82-2.71a23.46,23.46,0,0,1-5.82-4.8,6.39,6.39,0,0,0-.93.32c-4.65,2-8.13,5.74-11.61,9.29-2.48,2.52-4.88,5.13-7.2,7.79a5.23,5.23,0,0,0-.53-1,3.45,3.45,0,0,1-3.33-.7c-1-.83-2.08-1.59-3.16-2.36a6.57,6.57,0,0,0-4.86,2.63c-5.19,6.75-19.75,25.16-14.9,35.56a31.31,31.31,0,0,0-6,8A8.09,8.09,0,0,0,170.43,205.39Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.13,195.07h0l-11.52,6.36a.44.44,0,0,1-.58-.21.43.43,0,0,1,.12-.6l11.19-6.17-3.17-6.31a.42.42,0,0,1,.16-.58.45.45,0,0,1,.58.24l3.36,6.7A.44.44,0,0,1,308.13,195.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.85,203.28l-.07,0a.47.47,0,0,1-.56-.29L309,197.84C307,199,298.8,204,298,204.58a.44.44,0,0,1-.59-.15.45.45,0,0,1,.06-.62c.92-.66,11-6.75,11.4-7a.39.39,0,0,1,.35,0,.57.57,0,0,1,.28.27l2.47,5.7A.41.41,0,0,1,311.85,203.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.32,201.06l-.06,0a.46.46,0,0,1-.57-.28l-2.58-5.92a.44.44,0,0,1,.16-.56L324,188.46a.45.45,0,0,1,.58.23.42.42,0,0,1-.15.59L313,195l2.41,5.54A.42.42,0,0,1,315.32,201.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,186.21l-10.31,6.6a.44.44,0,0,1-.59-.17l-4.1-6.26a.43.43,0,0,1,.08-.61.45.45,0,0,1,.59.16l3.85,5.88,10-6.38a.44.44,0,0,1,.59.17A.43.43,0,0,1,322,186.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.06,190.05a.38.38,0,0,1-.4,0,.5.5,0,0,1-.24-.61l3.37-8.57a.37.37,0,0,1,.55-.17.52.52,0,0,1,.24.61l-3.38,8.57A.39.39,0,0,1,312.06,190.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.52,189.86a.39.39,0,0,1-.44,0,.49.49,0,0,1-.19-.62l3.81-7.72a.37.37,0,0,1,.56-.12.49.49,0,0,1,.19.62l-3.8,7.72A.44.44,0,0,1,314.52,189.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.14,197.22a.34.34,0,0,1-.23.05l-9-.88a.5.5,0,0,1-.43-.49.36.36,0,0,1,.4-.4l9,.88a.5.5,0,0,1,.44.48A.39.39,0,0,1,323.14,197.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.48,193.92a.37.37,0,0,1-.21.06l-10.4-.46a.51.51,0,0,1-.46-.47.37.37,0,0,1,.38-.43l10.4.46a.5.5,0,0,1,.46.47A.37.37,0,0,1,326.48,193.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.83,196.57l-.07,0c-7.27,2.53-28.45,14.07-28.66,14.18a.44.44,0,0,1-.58-.21.43.43,0,0,1,.12-.6c.21-.11,20.74-11.29,28.39-14.09-1-2.45-6.13-14.87-9-17.9a.46.46,0,0,1,0-.63.4.4,0,0,1,.59,0c3.28,3.48,9.1,18,9.35,18.64A.42.42,0,0,1,328.83,196.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.42,211.24l-.13,0a.48.48,0,0,1-.52-.37c-2.47-9.07-8.47-17.84-8.53-17.92a.49.49,0,0,1-.09-.37.36.36,0,0,1,.19-.27c8.29-4.38,28.14-15.72,28.34-15.84a.45.45,0,0,1,.59.2.44.44,0,0,1-.12.61c-.19.11-19.46,11.11-28,15.63,1.24,1.9,6.18,9.73,8.38,17.82A.39.39,0,0,1,298.42,211.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.35,193a.3.3,0,0,1-.21.05l-12.42-.7a.5.5,0,0,1-.46-.47.37.37,0,0,1,.39-.42l12.42.7a.5.5,0,0,1,.45.47A.37.37,0,0,1,306.35,193Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.3,196a.4.4,0,0,1-.22.06l-10.65-.7a.51.51,0,0,1-.46-.47.37.37,0,0,1,.4-.42l10.65.69a.52.52,0,0,1,.45.48A.39.39,0,0,1,303.3,196Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.58,209.53a.39.39,0,0,1-.47,0,.49.49,0,0,1-.14-.63l6.2-9.77a.38.38,0,0,1,.58-.06.49.49,0,0,1,.14.63l-6.2,9.76A.29.29,0,0,1,299.58,209.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.73,206.24a.41.41,0,0,1-.47-.05.49.49,0,0,1-.14-.63l4.14-6.53a.39.39,0,0,1,.58-.07.49.49,0,0,1,.14.63l-4.14,6.54A.38.38,0,0,1,304.73,206.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.78,225.18a.5.5,0,0,1-.57-.41c-3.69-21.28-12.92-32.46-13-32.57a.49.49,0,0,1,.06-.7.51.51,0,0,1,.71.06c.09.11,9.49,11.48,13.22,33a.5.5,0,0,1-.41.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.87,254.25a.26.26,0,0,1-.15,0l-7.14-5.07c-1.24.57-10.46,4.43-17.11-2.27-2.87-2.88-3-7.32-.3-11.32a14.27,14.27,0,0,1,17.53-5.16c4.1,1.72,6.53,4,7.22,6.86,1,4.15-2.07,7.85-2.2,8a.25.25,0,1,1-.38-.32s3-3.68,2.09-7.57c-.65-2.68-3-4.87-6.93-6.52a13.78,13.78,0,0,0-16.91,5c-2,3-3,7.41.23,10.69,6.86,6.89,16.57,2.16,16.67,2.11a.27.27,0,0,1,.26,0L330,253.1,327.54,249a.25.25,0,1,1,.43-.25l3.11,5.14a.26.26,0,0,1,0,.31A.23.23,0,0,1,330.87,254.25Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186,263.24a.25.25,0,0,1-.19-.09.26.26,0,0,1,0-.31l2.43-3.25-8.74.32a.25.25,0,0,1-.26-.24.26.26,0,0,1,.24-.26l9.27-.34a.26.26,0,0,1,.23.13.29.29,0,0,1,0,.27l-2.15,2.87,4.76-2.22a.18.18,0,0,1,.1,0h12.42V246.18c-10.06-.13-25-.23-26.24,0-.19.64.54,4.76,1.37,8.48a.25.25,0,0,1-.19.3.24.24,0,0,1-.29-.19c-1.28-5.71-1.67-8.75-1.17-9s20.65-.11,26.78,0a.25.25,0,0,1,.24.25v14.42a.25.25,0,0,1-.25.25H191.73l-5.61,2.62Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.91,172a.24.24,0,0,1-.2-.11l-3.88-5.27-14.25,1.73a.24.24,0,0,1-.18-.05.22.22,0,0,1-.09-.17L294.51,153a.25.25,0,0,1,.05-.19.31.31,0,0,1,.18-.09L316.66,151a.26.26,0,0,1,.27.23.26.26,0,0,1-.23.27L295,153.19l1.73,14.58,14.14-1.71a.25.25,0,0,1,.23.1l3,4-1.42-4a.24.24,0,0,1,0-.2.27.27,0,0,1,.17-.13l5.29-1-1.34-10.83a.26.26,0,0,1,.22-.28.25.25,0,0,1,.28.22l1.37,11.06a.27.27,0,0,1-.21.28l-5.23,1,1.9,5.31a.26.26,0,0,1-.12.31A.27.27,0,0,1,314.91,172Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M187.37,172.34c-6.1,0-13.06-2.49-14.61-7.26-2.54-7.81,6.3-12.54,7.91-13.32l-3.94-7.09a.26.26,0,0,1,.06-.31.25.25,0,0,1,.31,0l6.8,4.91a.25.25,0,1,1-.29.4l-5.89-4.25,3.52,6.34a.23.23,0,0,1,0,.2.27.27,0,0,1-.13.15c-.11,0-10.52,4.72-7.89,12.83,1.29,3.95,7.35,6.91,14.14,6.91h.1c6.85,0,11.85-2.93,13.37-7.76a7.19,7.19,0,0,0-.7-6.57c-3.47-4.93-13.56-5.39-13.66-5.39a.25.25,0,0,1-.24-.26.24.24,0,0,1,.26-.24c.42,0,10.43.47,14.05,5.6a7.65,7.65,0,0,1,.76,7c-1.59,5.05-6.76,8.07-13.83,8.11Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.15,160.79a.25.25,0,0,1-.25-.21l-.77-5.56-5.55-1a.25.25,0,0,1-.21-.23.26.26,0,0,1,.19-.26l5.55-1.48v-7.32a.25.25,0,0,1,.5,0v7.51a.25.25,0,0,1-.19.24l-4.64,1.24,4.62.81a.23.23,0,0,1,.2.21l.76,5.51,24.07-1.42V143.48H236.34a.25.25,0,0,1-.25-.25.25.25,0,0,1,.25-.25h23.34a.26.26,0,0,1,.25.25v15.86a.26.26,0,0,1-.24.25l-24.53,1.45Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.51,266.36a.26.26,0,0,1-.21-.11l-3-4.46a.25.25,0,0,1,.07-.35.24.24,0,0,1,.34.07l2.63,3.91.51-3.81a.26.26,0,0,1,.2-.21c.06,0,6.37-1.43,8.19-4.86a4.31,4.31,0,0,0,.11-3.75c-1.45-3.63-10-4.23-16.79-2.5-4.73,1.2-7.51,3.26-7.26,5.38.72,6.05,4.75,5.74,4.92,5.73a.24.24,0,0,1,.27.22.26.26,0,0,1-.22.28c-.05,0-4.68.38-5.46-6.17-.29-2.42,2.56-4.64,7.62-5.93,6.19-1.58,15.67-1.48,17.38,2.81a4.76,4.76,0,0,1-.13,4.16c-1.77,3.35-7.29,4.82-8.35,5.08l-.58,4.29a.26.26,0,0,1-.19.21Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M275,242.29c-1,0-2.73-.54-3.25-1.76a2.1,2.1,0,0,1,.57-2.37,1,1,0,0,1,1.49,1.42.68.68,0,0,0-.16.22,2.86,2.86,0,0,0,1.35.44,6.31,6.31,0,0,0,2.7-.61,2.19,2.19,0,0,0,1.19-1,1,1,0,0,0,0-.87,3.47,3.47,0,0,0-2.11-1.32c-.83-.22-1.67-.47-2.49-.75a3.5,3.5,0,0,1-1.87-1.2,3.2,3.2,0,0,1,.12-3.46c.94-1.69,2.82-3.47,4.68-3.38a3.08,3.08,0,0,1,2.7,2.18,1,1,0,0,1-1.89.81c-.26-.6-.57-.92-.91-.93-.76-.05-2.08,1-2.79,2.32-.29.53-.39,1.05-.23,1.27a2,2,0,0,0,.85.45c.77.26,1.56.49,2.34.7a5.47,5.47,0,0,1,3.41,2.35,3,3,0,0,1,.15,2.53,4.06,4.06,0,0,1-2.25,2.19,8.59,8.59,0,0,1-3.56.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.34,241.46c-1.52,0-2.72-.31-3.28-1.12-1.78-2.54-.59-20.21-.18-25.56a1,1,0,0,1,1.1-.95,1,1,0,0,1,1,1.1c-.82,10.8-1.11,22.82-.19,24.24.62.83,6.39-.09,13.18-2.57a1,1,0,1,1,.7,1.93C211.76,239.58,206.08,241.46,202.34,241.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,217.93a1,1,0,0,1-.07-2.06c.13,0,12.43-.83,16.24-1.4a1,1,0,1,1,.3,2c-3.89.58-15.89,1.38-16.4,1.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.71,228.69H198a1,1,0,0,1,0-2.06h8.76a1,1,0,0,1,0,2.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.87,242.3h-.08a1,1,0,0,1-.94-1.1c0-.08,0-.19,0-.32a116,116,0,0,0,0-13.16,1,1,0,1,1,2.05-.13c0,.15.1,1.68.16,3.84,1.13-2.56,2.82-4.65,5.33-4.8a4,4,0,0,1,3.18,1.05c1.75,1.69,1.67,4.92,1.59,8.06a20,20,0,0,0,.19,4.49,1,1,0,0,1-2,.47,21.47,21.47,0,0,1-.23-5c.06-2.57.13-5.47-1-6.54a2.09,2.09,0,0,0-1.63-.47c-3.73.22-5.29,8.95-5.59,12.39a2.64,2.64,0,0,0,0,.29A1,1,0,0,1,219.87,242.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.19,252.72c-2.9,0-5.78-.78-7.42-2.1a3.18,3.18,0,0,1-1.18-3.89,1,1,0,0,1,1.36-.53,1,1,0,0,1,.53,1.35c-.1.22-.32.74.58,1.46,2.35,1.9,8.63,2.36,11.58.22,2-1.42,1.79-6.51.88-11.6a6.65,6.65,0,0,1-4.3,3.92c-2.93.81-6.54-.66-7.75-5-.68-2.44-.41-4.47.81-6,2.37-3.05,7.48-3,7.69-3a1,1,0,0,1,1,1,1,1,0,0,1-1,1s-4.3-.06-6,2.17a4.62,4.62,0,0,0-.45,4.21c.89,3.22,3.34,4.13,5.23,3.61,2.51-.7,4.52-3.94,3-9.44a1,1,0,0,1,2-.58c.56,1.79,5.33,17.61.18,21.35A11.6,11.6,0,0,1,240.19,252.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.08,242.16a3.14,3.14,0,0,1-.94-.13,2,2,0,0,1-1.3-1.15c-1-2.32-.26-22.12-.09-26.07a1,1,0,0,1,1.07-1,1,1,0,0,1,1,1.07c-.39,9.54-.68,23.66-.08,25.15.47.37,3.3-.5,6.08-2.15a1,1,0,1,1,1.05,1.76C259.07,240.12,255.5,242.16,253.08,242.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.11,242.3a2,2,0,0,1-1.48-.64c-2.09-2.2-1.06-10.7-.69-13.26a1,1,0,1,1,2,.3c-.78,5.49-.7,11,.18,11.56a1,1,0,0,1,1.1.92,1,1,0,0,1-.94,1.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.4,224.71a1,1,0,0,1-.41-.09,1,1,0,0,1-.53-1.35l.91-2.08a1,1,0,0,1,1.88.82l-.91,2.08A1,1,0,0,1,263.4,224.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.36,243.07a1.05,1.05,0,0,1-.74-.31c-1.37-1.41-1.46-4-1.55-6.5-.15-4.17-.51-5.65-2.16-5.59-3.46.09-5.79,8.59-6.33,11.55a1,1,0,0,1-1.16.84,1,1,0,0,1-.88-1.13,142.68,142.68,0,0,0,0-26.33,1,1,0,0,1,2-.22,130.56,130.56,0,0,1,.53,18.36c1.31-2.71,3.19-5.06,5.74-5.12,4-.14,4.14,4.14,4.26,7.56.07,2,.16,4.3,1,5.14a1,1,0,0,1-.73,1.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.33,187.07h-.05a1.08,1.08,0,0,1-1-1.12,80.41,80.41,0,0,0-1.19-18.41,1.07,1.07,0,1,1,2.09-.46,80.81,80.81,0,0,1,1.24,19A1.07,1.07,0,0,1,211.33,187.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.47,168.68a1.07,1.07,0,0,1-.19-2.12l8.06-1.47a1.07,1.07,0,0,1,.38,2.11l-8.06,1.46A.58.58,0,0,1,205.47,168.68Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.61,188a1.07,1.07,0,0,1-.07-2.14l7.24-.47a1.07,1.07,0,0,1,.14,2.14l-7.24.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.38,187.11a2.86,2.86,0,0,1-1.16-.23c-.69-.29-2.12-.89-2-21.33a1,1,0,0,1,1.08-1.06,1.06,1.06,0,0,1,1.06,1.08c-.06,8.31.27,17.57.9,19.4a3,3,0,0,0,1.76-.78,1.07,1.07,0,0,1,1.51.08,1.05,1.05,0,0,1-.07,1.5A5.11,5.11,0,0,1,221.38,187.11Zm0-2h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.73,177.79a1.07,1.07,0,0,1-.19-2.12l5.6-1a1.07,1.07,0,0,1,.38,2.11l-5.6,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.34,174.21a1.07,1.07,0,0,1-.45-2,6.12,6.12,0,0,0,.61-2.18,1.07,1.07,0,1,1,2.13.25c-.11.95-.52,3.24-1.83,3.86A1.06,1.06,0,0,1,225.34,174.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.81,186.23a3.3,3.3,0,0,1-2.89-1.45,2,2,0,0,1,.38-2.28,1.06,1.06,0,0,1,1.5-.14,1.07,1.07,0,0,1,.14,1.51h0a2,2,0,0,0,.92.2,5.32,5.32,0,0,0,2.24-.65,1.74,1.74,0,0,0,.89-.85.68.68,0,0,0-.06-.61,2.82,2.82,0,0,0-1.78-.95q-1.12-.21-2.22-.51a3.36,3.36,0,0,1-1.78-1,3,3,0,0,1-.12-3.19c.75-1.57,2.33-3.27,4-3.3a2.9,2.9,0,0,1,2.63,1.83,1.07,1.07,0,1,1-1.91,1c-.15-.3-.43-.62-.68-.66-.61,0-1.62,1-2.13,2.07-.23.48-.23.84-.15.94a1.82,1.82,0,0,0,.67.27c.67.18,1.37.34,2.06.47a5.08,5.08,0,0,1,3.21,1.94,2.86,2.86,0,0,1,.28,2.33,3.65,3.65,0,0,1-1.91,2.13,7.56,7.56,0,0,1-3.12.91Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.81,186.46a2.89,2.89,0,0,1-1.16-.23c-.69-.29-2.12-.89-2-21.33a1,1,0,0,1,1.07-1.06,1.07,1.07,0,0,1,1.07,1.08c-.06,8.31.26,17.57.9,19.4a3,3,0,0,0,1.76-.78,1.07,1.07,0,0,1,1.44,1.58A5.14,5.14,0,0,1,247.81,186.46Zm0-2h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.16,177.14a1.08,1.08,0,0,1-1-.88A1.06,1.06,0,0,1,243,175l5.6-1a1.07,1.07,0,1,1,.39,2.11l-5.6,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,188.15a2.11,2.11,0,0,1-1.54-.68c-2.18-2.28-1.11-11.14-.73-13.8a1.07,1.07,0,0,1,1.21-.91,1.08,1.08,0,0,1,.91,1.21c-.82,5.73-.73,11.47.18,12.05a1.06,1.06,0,0,1,1.16.95,1.1,1.1,0,0,1-1,1.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.21,169.82a1.07,1.07,0,0,1-1-1.5l.94-2.16a1.07,1.07,0,0,1,1.41-.55,1.06,1.06,0,0,1,.55,1.4l-.94,2.17A1.08,1.08,0,0,1,254.21,169.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.45,184.94a25.89,25.89,0,0,1-.15-4.67c.06-3.27.13-6.64-1.31-8.4a2.93,2.93,0,0,0-2.61-1.09c-1.58.12-2.76,1.44-3.64,3.25a5.26,5.26,0,0,0-.94-2.07,2.9,2.9,0,0,0-2.61-1.08c-2.06.15-3.45,2.33-4.38,5-.05-2.26-.12-3.85-.13-4,0-.59-.44-1-.9-1A1,1,0,0,0,260,172c0,.08.38,7.86,0,13.71,0,.13,0,.25,0,.32a1,1,0,0,0,.78,1.15h.07a1,1,0,0,0,.84-1c0-.1,0-.2,0-.3.24-3.58,1.52-12.67,4.58-12.9a1.5,1.5,0,0,1,1.35.49c.9,1.11.84,4.14.79,6.81a27.62,27.62,0,0,0,.19,5.21c.11.58.56.94,1,.8a1.12,1.12,0,0,0,.63-1.29,25.85,25.85,0,0,1-.15-4.67c0-.75,0-1.51,0-2.25.73-2.75,1.81-5.08,3.35-5.19a1.47,1.47,0,0,1,1.34.49c.9,1.1.84,4.13.79,6.8a28.6,28.6,0,0,0,.19,5.22.87.87,0,0,0,1,.8A1.12,1.12,0,0,0,277.45,184.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.56,187.93a5,5,0,0,1-3.75-1.81,11.24,11.24,0,0,1-2.25-9.17c.39-2.52,1.42-4.48,2.75-5.26s2.91-.67,5,.12c1.38.51,4.1,1.89,4.45,2.92s.52,1.54-10.16,5.78a7.75,7.75,0,0,0,1.76,4.18,2.67,2.67,0,0,0,3.51.74c1.54-.8,2.4-2.5,2.23-3.25a1.07,1.07,0,0,1,2.09-.49c.43,1.9-1.09,4.48-3.34,5.64A5,5,0,0,1,284.56,187.93Zm-1.19-14.62a1.93,1.93,0,0,0-1,.22c-.61.36-1.4,1.68-1.72,3.75a9.17,9.17,0,0,0-.11.95c2.93-1.18,5.93-2.47,7.45-3.24A10.8,10.8,0,0,0,283.37,173.31Zm5.52,2.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.36,208.77a2.32,2.32,0,0,1-.87-.17c-.51-.22-1.58-.67-1.47-16a.77.77,0,0,1,.8-.79.8.8,0,0,1,.8.81c-.05,6.21.2,13.14.67,14.51a2.23,2.23,0,0,0,1.32-.58.8.8,0,0,1,1.13,0,.81.81,0,0,1-.05,1.13A3.93,3.93,0,0,1,220.36,208.77Zm0-1.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.88,201.8a.8.8,0,0,1-.14-1.59l4.19-.77a.8.8,0,0,1,.29,1.58l-4.19.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.74,209.37a3.5,3.5,0,0,1-2.26-.91,5.82,5.82,0,0,1-1.75-7.15,5.47,5.47,0,0,1,5.82-3.21.82.82,0,0,1,.64.94h0a2.63,2.63,0,0,1,2.35,1.51c1,2.14-.31,6.25-2.58,8A3.65,3.65,0,0,1,227.74,209.37Zm.66-9.74a4.11,4.11,0,0,0-3.23,2.37,4.24,4.24,0,0,0,1.35,5.24,1.75,1.75,0,0,0,2.46,0c1.67-1.28,2.81-4.55,2.11-6-.11-.23-.4-.84-1.77-.51a.79.79,0,0,1-1-.59A.84.84,0,0,1,228.4,199.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.81,209.46a2.25,2.25,0,0,1-.87-.17c-.52-.22-1.59-.67-1.48-16a.78.78,0,0,1,.81-.79.79.79,0,0,1,.79.8c0,6.22.2,13.15.68,14.51a2.09,2.09,0,0,0,1.31-.58.8.8,0,0,1,1.13.06.79.79,0,0,1-.05,1.13A3.89,3.89,0,0,1,240.81,209.46Zm0-1.46h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.74,208.69a2.57,2.57,0,0,1-1.86-1.61,10.75,10.75,0,0,1-.32-7c.46-1.83,1.2-3.22,2-3.71s1.64-.29,2.71.45c.7.48,2,1.7,2.12,2.48s.14,1.18-6,3.57a7.15,7.15,0,0,0,.54,3.23c.45.93,1.07,1.2,1.83.79a3.11,3.11,0,0,0,1.52-2.25.86.86,0,0,1,.56-.9c.32-.05.6.25.62.69a4.81,4.81,0,0,1-2.35,3.94A2.12,2.12,0,0,1,246.74,208.69Zm.77-10.92a.81.81,0,0,0-.54.09,5,5,0,0,0-1.3,2.66q-.07.33-.15.69c1.7-.66,3.45-1.41,4.34-1.87A4.92,4.92,0,0,0,247.51,197.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.24,209.6a2.86,2.86,0,0,1-2.16-1.08,6.79,6.79,0,0,1-1-6.31c1.11-3.55,3.79-3.42,5.05-2.86a.93.93,0,0,1,.4,1.08c-.11.44-.48.67-.82.52s-2.52-1-3.43,1.9a4.76,4.76,0,0,0,.67,4.4,1.68,1.68,0,0,0,2.46.23c1.7-1.26,1.7-4.88,1.58-6.68,0-.41-.08-.79-.11-1.1a.84.84,0,0,1,.55-.93c.35-.07.67.24.74.68,0,.07.07.51.11,1.18.31,3,.82,6.13,1.18,6.62,0,0,.08.09.12.07s.37-.37.49-.64a.58.58,0,0,1,.88-.32,1,1,0,0,1,.25,1.14c-.09.21-.58,1.29-1.39,1.48a1.19,1.19,0,0,1-1.2-.46,5.87,5.87,0,0,1-.83-2.26,5.13,5.13,0,0,1-1.72,2.68A3.06,3.06,0,0,1,255.24,209.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.8,209.41h-.05a.74.74,0,0,1-.61-.83c0-.06,0-.14,0-.24.28-4.25,0-9.9,0-10a.75.75,0,0,1,.62-.83.71.71,0,0,1,.7.73c0,.11.07,1.27.11,2.9.73-1.94,1.82-3.52,3.44-3.63a2.4,2.4,0,0,1,2.05.79c1.13,1.28,1.08,3.73,1,6.1a17,17,0,0,0,.12,3.4.79.79,0,0,1-.5.93.66.66,0,0,1-.79-.58,18.1,18.1,0,0,1-.16-3.79c0-1.94.09-4.14-.62-4.94a1.22,1.22,0,0,0-1.06-.36c-2.4.17-3.41,6.77-3.6,9.37,0,.08,0,.15,0,.22A.72.72,0,0,1,271.8,209.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,199.21a2.93,2.93,0,0,1,.69,1.26.77.77,0,0,0,.72.6h0c.4,0,.64-.51.47-1a4.49,4.49,0,0,0-1.17-2,2.5,2.5,0,0,0-2.1-.61c-1.53.23-2.33,1.83-2.73,3.75-.29-1.57-.53-2.68-.55-2.78a.76.76,0,0,0-.79-.65.66.66,0,0,0-.46.84c0,.06,1.16,5.46,1.55,9.57,0,.1,0,.17,0,.23a.79.79,0,0,0,.71.75h.06a.63.63,0,0,0,.52-.73c0-.07,0-.15,0-.22-.22-2.51-.27-8.93,2-9.27A1.24,1.24,0,0,1,268,199.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.88,195.07h0l11.53,6.36a.44.44,0,0,0,.58-.21.43.43,0,0,0-.12-.6l-11.19-6.17,3.16-6.31a.41.41,0,0,0-.15-.58.45.45,0,0,0-.58.24l-3.36,6.7A.43.43,0,0,0,185.88,195.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.16,203.28l.07,0a.47.47,0,0,0,.56-.29l2.26-5.19C187,199,195.21,204,196,204.58a.48.48,0,0,0,.54-.77c-.92-.66-11-6.75-11.41-7a.37.37,0,0,0-.34,0,.57.57,0,0,0-.28.27l-2.48,5.7A.42.42,0,0,0,182.16,203.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.69,201.06s0,0,.06,0a.47.47,0,0,0,.57-.28l2.57-5.92a.43.43,0,0,0-.15-.56L170,188.46a.45.45,0,0,0-.58.23.42.42,0,0,0,.14.59L181,195l-2.41,5.54A.42.42,0,0,0,178.69,201.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,186.21l10.31,6.6a.43.43,0,0,0,.58-.17l4.11-6.26a.44.44,0,0,0-.08-.61.45.45,0,0,0-.59.16l-3.85,5.88-10-6.38a.44.44,0,0,0-.59.17A.43.43,0,0,0,172,186.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.94,190.05a.4.4,0,0,0,.41,0,.51.51,0,0,0,.24-.61l-3.37-8.57a.37.37,0,0,0-.55-.17.51.51,0,0,0-.24.61l3.37,8.57A.39.39,0,0,0,181.94,190.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.49,189.86a.39.39,0,0,0,.44,0,.5.5,0,0,0,.19-.62l-3.81-7.72a.37.37,0,0,0-.56-.12.5.5,0,0,0-.2.62l3.81,7.72A.35.35,0,0,0,179.49,189.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.87,197.22a.34.34,0,0,0,.23.05l9-.88a.51.51,0,0,0,.44-.49.36.36,0,0,0-.4-.4l-9,.88a.49.49,0,0,0-.43.48A.39.39,0,0,0,170.87,197.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.52,193.92a.4.4,0,0,0,.22.06l10.4-.46a.52.52,0,0,0,.46-.47.38.38,0,0,0-.39-.43l-10.4.46a.52.52,0,0,0-.46.47A.4.4,0,0,0,167.52,193.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.18,196.57l.07,0c7.27,2.53,28.44,14.07,28.66,14.18a.44.44,0,0,0,.58-.21.43.43,0,0,0-.12-.6c-.21-.11-20.74-11.29-28.39-14.09,1-2.45,6.12-14.87,9-17.9a.47.47,0,0,0,0-.63.41.41,0,0,0-.6,0c-3.27,3.48-9.09,18-9.34,18.64A.42.42,0,0,0,165.18,196.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.59,211.24l.13,0a.49.49,0,0,0,.52-.37c2.47-9.07,8.47-17.84,8.53-17.92a.54.54,0,0,0,.08-.37.32.32,0,0,0-.19-.27c-8.28-4.38-28.13-15.72-28.33-15.84a.45.45,0,0,0-.59.2.44.44,0,0,0,.11.61c.2.11,19.46,11.11,28,15.63-1.24,1.9-6.18,9.73-8.39,17.82A.41.41,0,0,0,195.59,211.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.65,193a.33.33,0,0,0,.22.05l12.42-.7a.5.5,0,0,0,.45-.47.36.36,0,0,0-.38-.42l-12.42.7a.51.51,0,0,0-.46.47A.4.4,0,0,0,187.65,193Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.71,196a.38.38,0,0,0,.22.06l10.65-.7a.5.5,0,0,0,.45-.47.36.36,0,0,0-.39-.42l-10.65.69a.5.5,0,0,0-.45.48A.35.35,0,0,0,190.71,196Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.43,209.53a.4.4,0,0,0,.47,0,.49.49,0,0,0,.14-.63l-6.2-9.77a.38.38,0,0,0-.58-.06.49.49,0,0,0-.14.63l6.2,9.76A.29.29,0,0,0,194.43,209.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.28,206.24a.41.41,0,0,0,.47-.05.49.49,0,0,0,.14-.63L185.75,199a.39.39,0,0,0-.58-.07.48.48,0,0,0-.14.63l4.14,6.54A.38.38,0,0,0,189.28,206.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.23,225.18a.5.5,0,0,0,.57-.41c3.68-21.28,12.91-32.46,13-32.57a.5.5,0,0,0-.77-.64c-.09.11-9.49,11.48-13.22,33a.5.5,0,0,0,.4.58Z",
    style: {
      fill: "#fff"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginSvg);
export default __webpack_public_path__ + "static/media/LoginSVG.6fa554220bcc1b7e0a28381f90bbbafa.svg";
export { ForwardRef as ReactComponent };